import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from '../layouts/full/shared/loadable/Loadable';

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

/* ****Pages***** */
const ModernDash = Loadable(lazy(() => import('../views/dashboard/Modern')));
const EcommerceDash = Loadable(lazy(() => import('../views/dashboard/Ecommerce')));

/* ****Apps***** */
const EmployeeAttendance = Loadable(lazy(() => import('../views/attendance/EmployeeAttendance')));
const CheckAttendance = Loadable(lazy(() => import('../views/attendance/CheckAttendance')));
const UpdateAttendance = Loadable(lazy(() => import('../views/attendance/UpdateAttendance')));
const AllAttendance = Loadable(lazy(() => import('../views/attendance/AllAttendance')));
const EmployeeDetails = Loadable(lazy(() => import('../views/Employees/EmployeeDetails')));
const ViewDetails = Loadable(lazy(() => import('../views/Employees/ViewDetails')));
const EmployeesList = Loadable(lazy(() => import('../views/Employees/EmployeesList')));
const AddEmployee = Loadable(lazy(() => import('../views/Employees/AddEmployee')));
const ChangePassword = Loadable(lazy(() => import('../views/Employees/ChangePassword')));
const UpdatePassword = Loadable(lazy(() => import('../views/Employees/UpdatePassword')));
const EditEmployee = Loadable(lazy(() => import('../views/Employees/EditEmployee')));
const EditDetails = Loadable(lazy(() => import('../views/Employees/EditDetails')));
const UpdateDetails = Loadable(lazy(() => import('../views/Employees/UpdateDetails')));
const Designation = Loadable(lazy(() => import('../views/Employees/Designation')));
const Department = Loadable(lazy(() => import('../views/Employees/Department')));
const Role = Loadable(lazy(() => import('../views/user-management/Role')));
const AccountDetails = Loadable(lazy(() => import('../views/company-management/AccountDetails')));
const CompaniesList = Loadable(lazy(() => import('../views/company-management/CompaniesList')));
const AddCompany = Loadable(lazy(() => import('../views/company-management/AddCompany')));
const Chats = Loadable(lazy(() => import('../views/apps/chat/Chat')));
const Notes = Loadable(lazy(() => import('../views/apps/notes/Notes')));
const Calendar = Loadable(lazy(() => import('../views/apps/calendar/BigCalendar')));
const Email = Loadable(lazy(() => import('../views/apps/email/Email')));
const Blog = Loadable(lazy(() => import('../views/apps/blog/Blog')));
const AddClient = Loadable(lazy(() => import('../views/clients/AddClient')));
const ClientsList = Loadable(lazy(() => import('../views/clients/ClientsList')));
const EditClient = Loadable(lazy(() => import('../views/clients/EditClient')));
const AddProduct = Loadable(lazy(() => import('../views/products/AddProduct')));
const ProductsList = Loadable(lazy(() => import('../views/products/ProductsList')));
const EditProduct = Loadable(lazy(() => import('../views/products/EditProduct')));
const CreateInvoice = Loadable(lazy(() => import('../views/invoice/CreateInvoice')));
const ProformaInvoice = Loadable(lazy(() => import('../views/invoice/ProformaInvoice.js')))
const InvoiceList = Loadable(lazy(() => import('../views/invoice/InvoiceList')));
const ProformaInvoiceList = Loadable(lazy(() => import(('../views/invoice/ProformaInvoiceList'))))
const ViewInvoice = Loadable(lazy(() => import('../views/invoice/ViewInvoice')));
const ViewProformaInvoice = Loadable(lazy(() => import('../views/invoice/ViewPerformaInvoice')))
const EditInvoice = Loadable(lazy(() => import('../views/invoice/EditInvoice')));
const EditProformaInvoice = Loadable(lazy(() => import('../views/invoice/EditProformaInvoice')));
const BlogDetail = Loadable(lazy(() => import('../views/apps/blog/BlogPost')));
const Tickets = Loadable(lazy(() => import('../views/apps/tickets/Tickets')));
const Contacts = Loadable(lazy(() => import('../views/apps/contacts/Contacts')));
const Ecommerce = Loadable(lazy(() => import('../views/apps/eCommerce/Ecommerce')));
const EcommerceDetail = Loadable(lazy(() => import('../views/apps/eCommerce/EcommerceDetail')));
const EcomProductList = Loadable(lazy(() => import('../views/apps/eCommerce/EcomProductList')));
const EcomProductCheckout = Loadable(lazy(() => import('../views/apps/eCommerce/EcommerceCheckout')));
const UserProfile = Loadable(lazy(() => import('../views/apps/user-profile/UserProfile')));
const Followers = Loadable(lazy(() => import('../views/apps/user-profile/Followers')));
const Friends = Loadable(lazy(() => import('../views/apps/user-profile/Friends')));
const Gallery = Loadable(lazy(() => import('../views/apps/user-profile/Gallery')));

// Pages
const RollbaseCASL = Loadable(lazy(() => import('../views/pages/rollbaseCASL/RollbaseCASL')));
const Treeview = Loadable(lazy(() => import('../views/pages/treeview/Treeview')));
const Pricing = Loadable(lazy(() => import('../views/pages/pricing/Pricing')));
const AccountSetting = Loadable(
  lazy(() => import('../views/pages/account-setting/AccountSetting')),
);
const Faq = Loadable(lazy(() => import('../views/pages/faq/Faq')));

// widget
const WidgetCards = Loadable(lazy(() => import('../views/widgets/cards/WidgetCards')));
const WidgetBanners = Loadable(lazy(() => import('../views/widgets/banners/WidgetBanners')));
const WidgetCharts = Loadable(lazy(() => import('../views/widgets/charts/WidgetCharts')));

// form elements
const MuiAutoComplete = Loadable(
  lazy(() => import('../views/forms/form-elements/MuiAutoComplete')),
);
const MuiButton = Loadable(lazy(() => import('../views/forms/form-elements/MuiButton')));
const MuiCheckbox = Loadable(lazy(() => import('../views/forms/form-elements/MuiCheckbox')));
const MuiRadio = Loadable(lazy(() => import('../views/forms/form-elements/MuiRadio')));
const MuiSlider = Loadable(lazy(() => import('../views/forms/form-elements/MuiSlider')));
const MuiDateTime = Loadable(lazy(() => import('../views/forms/form-elements/MuiDateTime')));
const MuiSwitch = Loadable(lazy(() => import('../views/forms/form-elements/MuiSwitch')));

// form layout
const FormLayouts = Loadable(lazy(() => import('../views/forms/FormLayouts')));
const FormCustom = Loadable(lazy(() => import('../views/forms/FormCustom')));
const FormWizard = Loadable(lazy(() => import('../views/forms/FormWizard')));
const FormValidation = Loadable(lazy(() => import('../views/forms/FormValidation')));
const QuillEditor = Loadable(lazy(() => import('../views/forms/quill-editor/QuillEditor')));
const FormHorizontal = Loadable(lazy(() => import('../views/forms/FormHorizontal')));
const FormVertical = Loadable(lazy(() => import('../views/forms/FormVertical')));

// tables
const BasicTable = Loadable(lazy(() => import('../views/tables/BasicTable')));
const CollapsibleTable = Loadable(lazy(() => import('../views/tables/CollapsibleTable')));
const EnhancedTable = Loadable(lazy(() => import('../views/tables/EnhancedTable')));
const FixedHeaderTable = Loadable(lazy(() => import('../views/tables/FixedHeaderTable')));
const PaginationTable = Loadable(lazy(() => import('../views/tables/PaginationTable')));
const SearchTable = Loadable(lazy(() => import('../views/tables/SearchTable')));

// chart
const LineChart = Loadable(lazy(() => import('../views/charts/LineChart')));
const GredientChart = Loadable(lazy(() => import('../views/charts/GredientChart')));
const DoughnutChart = Loadable(lazy(() => import('../views/charts/DoughnutChart')));
const AreaChart = Loadable(lazy(() => import('../views/charts/AreaChart')));
const ColumnChart = Loadable(lazy(() => import('../views/charts/ColumnChart')));
const CandlestickChart = Loadable(lazy(() => import('../views/charts/CandlestickChart')));
const RadialbarChart = Loadable(lazy(() => import('../views/charts/RadialbarChart')));

// ui
const MuiAlert = Loadable(lazy(() => import('../views/ui-components/MuiAlert')));
const MuiAccordion = Loadable(lazy(() => import('../views/ui-components/MuiAccordion')));
const MuiAvatar = Loadable(lazy(() => import('../views/ui-components/MuiAvatar')));
const MuiChip = Loadable(lazy(() => import('../views/ui-components/MuiChip')));
const MuiDialog = Loadable(lazy(() => import('../views/ui-components/MuiDialog')));
const MuiList = Loadable(lazy(() => import('../views/ui-components/MuiList')));
const MuiPopover = Loadable(lazy(() => import('../views/ui-components/MuiPopover')));
const MuiRating = Loadable(lazy(() => import('../views/ui-components/MuiRating')));
const MuiTabs = Loadable(lazy(() => import('../views/ui-components/MuiTabs')));
const MuiTooltip = Loadable(lazy(() => import('../views/ui-components/MuiTooltip')));
const MuiTransferList = Loadable(lazy(() => import('../views/ui-components/MuiTransferList')));
const MuiTypography = Loadable(lazy(() => import('../views/ui-components/MuiTypography')));

// authentication
const Login = Loadable(lazy(() => import('../views/authentication/auth1/Login')));
const Login2 = Loadable(lazy(() => import('../views/authentication/auth2/Login2')));
const Register = Loadable(lazy(() => import('../views/authentication/auth1/Register')));
const Register2 = Loadable(lazy(() => import('../views/authentication/auth2/Register2')));
const ForgotPassword = Loadable(lazy(() => import('../views/authentication/auth1/ForgotPassword')));
const ForgotPassword2 = Loadable(
  lazy(() => import('../views/authentication/auth2/ForgotPassword2')),
);
const TwoSteps = Loadable(lazy(() => import('../views/authentication/auth1/TwoSteps')));
const TwoSteps2 = Loadable(lazy(() => import('../views/authentication/auth2/TwoSteps2')));
const Error = Loadable(lazy(() => import('../views/authentication/Error')));
const Maintenance = Loadable(lazy(() => import('../views/authentication/Maintenance')));

// landingpage
const Landingpage = Loadable(lazy(() => import('../views/pages/landingpage/Landingpage')));

const Router = [
  {
    path: '/',
    element: <FullLayout allowedRoles={['admin', 'editor', 'hr', 'user', 'accountant']} />,
    children: [
      // { path: '/', element: <Navigate to="/landingpage" /> },
      { path: '/user-dashboard', element: <ModernDash /> },
      { path: '/admin-dashboard', element: <ModernDash /> },
      { path: '/editor-dashboard', element: <ModernDash /> },
      { path: '/hr-dashboard', element: <ModernDash /> },
      { path: '/accountant-dashboard', element: <ModernDash /> },
      { path: '/update-password', element: <UpdatePassword /> },
      { path: '/update-details', element: <UpdateDetails /> },
      { path: '/view-details', element: <ViewDetails /> },
      { path: '/check-attendance', element: <CheckAttendance /> },
      { path: '/dashboards/ecommerce', exact: true, element: <EcommerceDash /> },
      { path: '/roles', element: <Role /> },
      { path: '/add-client', element: <AddClient /> },
      { path: '/edit-client/:id', element: <EditClient /> },
      { path: '/clients-list', element: <ClientsList /> },
      { path: '/add-product', element: <AddProduct /> },
      { path: '/edit-product/:id', element: <EditProduct /> },
      { path: '/products-list', element: <ProductsList /> },
      { path: '/create-invoice', element: <CreateInvoice /> },
      { path: '/invoice-list', element: <InvoiceList /> },
      { path: '/create-proforma-invoice', element: <ProformaInvoice /> },
      { path: '/proforma-list', element: <ProformaInvoiceList /> },
      { path: '/apps/chats', element: <Chats /> },
      { path: '/apps/notes', element: <Notes /> },
      { path: '/apps/calendar', element: <Calendar /> },
      { path: '/apps/email', element: <Email /> },
      { path: '/apps/tickets', element: <Tickets /> },
      { path: '/apps/contacts', element: <Contacts /> },
      { path: '/apps/ecommerce/shop', element: <Ecommerce /> },
      { path: '/apps/blog/posts', element: <Blog /> },
      { path: '/apps/blog/detail/:id', element: <BlogDetail /> },
      { path: '/apps/ecommerce/eco-product-list', element: <EcomProductList /> },
      { path: '/apps/ecommerce/eco-checkout', element: <EcomProductCheckout /> },
      { path: '/apps/ecommerce/detail/:id', element: <EcommerceDetail /> },
      { path: '/apps/followers', element: <Followers /> },
      { path: '/apps/friends', element: <Friends /> },
      { path: '/apps/gallery', element: <Gallery /> },
      { path: '/user-profile', element: <UserProfile /> },
      { path: '/pages/casl', element: <RollbaseCASL /> },
      { path: '/pages/treeview', element: <Treeview /> },
      { path: '/pages/pricing', element: <Pricing /> },
      { path: '/pages/account-settings', element: <AccountSetting /> },
      { path: '/pages/faq', element: <Faq /> },
      { path: '/forms/form-elements/autocomplete', element: <MuiAutoComplete /> },
      { path: '/forms/form-elements/button', element: <MuiButton /> },
      { path: '/forms/form-elements/checkbox', element: <MuiCheckbox /> },
      { path: '/forms/form-elements/radio', element: <MuiRadio /> },
      { path: '/forms/form-elements/slider', element: <MuiSlider /> },
      { path: '/forms/form-elements/date-time', element: <MuiDateTime /> },
      { path: '/forms/form-elements/switch', element: <MuiSwitch /> },
      { path: '/forms/form-elements/switch', element: <MuiSwitch /> },
      { path: '/forms/quill-editor', element: <QuillEditor /> },
      { path: '/forms/form-layouts', element: <FormLayouts /> },
      { path: '/forms/form-horizontal', element: <FormHorizontal /> },
      { path: '/forms/form-vertical', element: <FormVertical /> },
      { path: '/forms/form-custom', element: <FormCustom /> },
      { path: '/forms/form-wizard', element: <FormWizard /> },
      { path: '/forms/form-validation', element: <FormValidation /> },
      { path: '/tables/basic', element: <BasicTable /> },
      { path: '/tables/collapsible', element: <CollapsibleTable /> },
      { path: '/tables/enhanced', element: <EnhancedTable /> },
      { path: '/tables/fixed-header', element: <FixedHeaderTable /> },
      { path: '/tables/pagination', element: <PaginationTable /> },
      { path: '/tables/search', element: <SearchTable /> },
      { path: '/charts/line-chart', element: <LineChart /> },
      { path: '/charts/gredient-chart', element: <GredientChart /> },
      { path: '/charts/doughnut-pie-chart', element: <DoughnutChart /> },
      { path: '/charts/area-chart', element: <AreaChart /> },
      { path: '/charts/column-chart', element: <ColumnChart /> },
      { path: '/charts/candlestick-chart', element: <CandlestickChart /> },
      { path: '/charts/radialbar-chart', element: <RadialbarChart /> },
      { path: '/ui-components/alert', element: <MuiAlert /> },
      { path: '/ui-components/accordion', element: <MuiAccordion /> },
      { path: '/ui-components/avatar', element: <MuiAvatar /> },
      { path: '/ui-components/chip', element: <MuiChip /> },
      { path: '/ui-components/dialog', element: <MuiDialog /> },
      { path: '/ui-components/list', element: <MuiList /> },
      { path: '/ui-components/popover', element: <MuiPopover /> },
      { path: '/ui-components/rating', element: <MuiRating /> },
      { path: '/ui-components/tabs', element: <MuiTabs /> },
      { path: '/ui-components/tooltip', element: <MuiTooltip /> },
      { path: '/ui-components/transfer-list', element: <MuiTransferList /> },
      { path: '/ui-components/typography', element: <MuiTypography /> },
      { path: '/widgets/cards', element: <WidgetCards /> },
      { path: '/widgets/banners', element: <WidgetBanners /> },
      { path: '/widgets/charts', element: <WidgetCharts /> },
      { path: '*', element: <Navigate to="/404" /> },
    ],
  },
  {
    path: '/',
    // Add 'accountant' to allowedRoles so they have all employee routes
    element: <FullLayout allowedRoles={['admin', 'editor', 'hr', 'accountant']} />,
    children: [
      { path: '/hr-dashboard', exact: true, element: <ModernDash /> },
      { path: '/employee-details/:id', element: <EmployeeDetails /> },
      { path: '/change-password/:id', element: <ChangePassword /> },
      { path: '/edit-details/:id', element: <EditDetails /> },
      { path: '/departments', element: <Department /> },
      { path: '/designations', element: <Designation /> },
      { path: '/employees-list', element: <EmployeesList /> },
      { path: '/add-employee', element: <AddEmployee /> },
      { path: '/edit-employee/:id', element: <EditEmployee /> },
      { path: '/update-attendance', element: <UpdateAttendance /> },
      { path: '/all-attendance', element: <AllAttendance /> },
      { path: '/employee-attendance', element: <EmployeeAttendance /> },
      { path: '*', element: <Navigate to="/404" /> },
    ],
  },
  {
    path: '/',
    element: <FullLayout allowedRoles={['admin', 'editor']} />,
    children: [
      { path: '/editor-dashboard', exact: true, element: <ModernDash /> },
      { path: '/add-product', element: <AddProduct /> },
      { path: '/edit-product/:id', element: <EditProduct /> },
      { path: '/products-list', element: <ProductsList /> },
      { path: '/create-invoice', element: <CreateInvoice /> },
      { path: '/create-proforma-invoice', element: <ProformaInvoice /> },
      { path: '/edit-invoice/:id', element: <EditInvoice /> },
      { path: '/edit-proforma-invoice/:id', element: <EditProformaInvoice /> },
      { path: '/invoice-list', element: <InvoiceList /> },
      { path: '/proforma-list', element: <ProformaInvoiceList /> },
      { path: '*', element: <Navigate to="/404" /> },
    ],
  },
  // Accountant: Company/accounting-specific routes as per menuItems only
  {
    path: '/',
    element: <FullLayout allowedRoles={['accountant']} />,
    children: [
      { path: '/accountant-dashboard', exact: true, element: <ModernDash /> },
      { path: '/clients-list', element: <ClientsList /> },
      { path: '/add-client', element: <AddClient /> },
      { path: '/invoice-list', element: <InvoiceList /> },
      { path: '/create-invoice', element: <CreateInvoice /> },
      { path: '/create-proforma-invoice', element: <ProformaInvoice /> },
      { path: '/proforma-list', element: <ProformaInvoiceList /> },
      { path: '/account-details', element: <AccountDetails /> },
      { path: '/companies-list', element: <CompaniesList /> },
      { path: '/add-company', element: <AddCompany /> },
      { path: '*', element: <Navigate to="/404" /> },
    ],
  },
  {
    path: '/',
    element: <FullLayout allowedRoles={['admin']} />,
    children: [
      { path: '/admin-dashboard', exact: true, element: <ModernDash /> },
      { path: '/account-details', element: <AccountDetails /> },
      { path: '/companies-list', element: <CompaniesList /> },
      { path: '/add-company', element: <AddCompany /> },
      { path: '*', element: <Navigate to="/404" /> },
    ],
  },
  {
    path: '/',
    element: <BlankLayout />,
    children: [
      { path: '/404', element: <Error /> },
      { path: '/login', element: <Login2 /> },
      { path: '/auth/login2', element: <Login /> },
      { path: '/view-invoice/:id', element: <ViewInvoice /> },
      { path: '/view-proforma-invoice/:id', element: <ViewProformaInvoice /> },
      { path: '/auth/register', element: <Register /> },
      { path: '/auth/register2', element: <Register2 /> },
      { path: '/auth/forgot-password', element: <ForgotPassword /> },
      { path: '/auth/forgot-password2', element: <ForgotPassword2 /> },
      { path: '/auth/two-steps', element: <TwoSteps /> },
      { path: '/auth/two-steps2', element: <TwoSteps2 /> },
      { path: '/auth/maintenance', element: <Maintenance /> },
      { path: '/landingpage', element: <Landingpage /> },
      { path: '*', element: <Navigate to="/404" /> },
    ],
  },
];

export default Router;
